/* mc-garde-robe-ledger.js: keeps the La Garde-Robe ledger line in the cart
 * drawer current. Subscribe-only mirror of mc-announcement-ledger.js: renders
 * from cartUpdate payloads when they carry totals, else debounced GET /cart.js
 * with a last-write-wins token. Never publishes cartUpdate (drawer race rule).
 * Also emits the optional PostHog tier event when the tier changes (posthog
 * only exists when consent allowed it to load, so no extra consent gate). */
(function () {
  if (window.customElements && customElements.get('mc-gr-ledger')) return;

  var DEBOUNCE_MS = 150;
  var lastTierSeen = null; // module-scoped: survives .drawer__inner destroy/recreate

  var McGrLedger = class extends HTMLElement {
    connectedCallback() {
      this.rowEl = this.querySelector('.mc-gr__row');
      this.amtEl = this.querySelector('.mc-gr__amt');
      this.teaserEl = this.querySelector('.mc-gr__teaser');
      this.t2 = this.getAttribute('data-t2') || '';
      this.t4 = this.getAttribute('data-teaser-4th') || '';
      this.t5 = this.getAttribute('data-teaser-5th') || '';
      this._token = 0;
      this._timer = null;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.unsub) this.unsub();
      if (this._timer) clearTimeout(this._timer);
    }

    onCartUpdate(event) {
      var d = event && event.cartData;
      if (d && typeof d.item_count === 'number' && typeof d.items_subtotal_price === 'number') {
        this.render(d.item_count, d.items_subtotal_price, d.currency);
      } else {
        this.refresh();
      }
    }

    refresh() {
      var self = this;
      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        var token = ++self._token;
        var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (token !== self._token) return; // stale response, drop it
            self.render(cart.item_count, cart.items_subtotal_price, cart.currency);
          })
          .catch(function () { /* keep the server-rendered state on failure */ });
      }, DEBOUNCE_MS);
    }

    formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency || 'CAD' }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    render(qty, subtotal, currency) {
      var pct = qty >= 5 ? 20 : qty >= 4 ? 15 : qty >= 3 ? 10 : 0;
      var showTeaser = qty >= 2 && qty <= 4;
      this.hidden = !(pct > 0 || qty === 2);
      if (this.rowEl) {
        this.rowEl.hidden = pct === 0;
        if (pct > 0 && this.amtEl) {
          this.amtEl.textContent = '−' + this.formatMoney(Math.floor((subtotal * pct) / 100), currency);
        }
      }
      if (this.teaserEl) {
        this.teaserEl.hidden = !showTeaser;
        if (showTeaser) {
          this.teaserEl.textContent = qty === 2 ? this.t2 : qty === 3 ? this.t4 : this.t5;
        }
      }
      if (pct !== lastTierSeen) {
        lastTierSeen = pct;
        try {
          if (window.posthog && typeof window.posthog.capture === 'function') {
            window.posthog.capture('mc_garde_robe_state', { items: qty, tier_pct: pct });
          }
        } catch (e) { /* analytics must never break the drawer */ }
      }
    }
  };

  window.customElements.define('mc-gr-ledger', McGrLedger);
})();
